// frontend/src/components/cohesion/EntityDrawer.Report.tsx
// Report panel — minimal placeholder pointing at the Reports hub. Reports
// are subject-typed views, not standalone entities — so the drawer just
// confirms the destination and hands off to /reports.

import { useLanguage } from '../../i18n/index.jsx'

type Lang = { t: (k: string) => string }

interface Props {
  id: number | string
  navigate: (to: string) => void
  closeDrawer: () => void
}

export default function EntityDrawerReport({ id, navigate, closeDrawer }: Props) {
  const { t } = useLanguage() as Lang
  const view = String(id)

  const open = () => {
    closeDrawer()
    navigate(`/reports?view=${encodeURIComponent(view)}`)
  }

  return (
    <>
      <button type="button" className="entity-drawer-title-link" onClick={open}>
        {t('reportsHubTitle')}: {view}
      </button>
      <div className="entity-drawer-meta">
        <div className="entity-drawer-meta-row">
          <span className="entity-drawer-meta-key">{t('reportsHubTitle')}</span>
          <span className="entity-drawer-meta-val">{view}</span>
        </div>
      </div>
      <div className="entity-drawer-actions">
        <button type="button" className="entity-drawer-action" onClick={open}>
          {t('openWorkspace')}
        </button>
      </div>
    </>
  )
}
